export const initIndicator = (column) => {
    if (column.isDisabled())
        return;
    column.getElement().querySelectorAll('[data-indicator-toggle]').forEach((toggleElement) => {
        let relatedSettings = column.getElement().querySelectorAll(`.ac-column-setting[data-setting='${toggleElement.dataset.setting}'] .col-input .ac-setting-input:first-child input[type=radio]`);
        toggleElement.addEventListener('click', () => {
            switchTo(!toggleElement.classList.contains('on'), relatedSettings);
        });
        relatedSettings.forEach(element => {
            element.addEventListener('change', () => {
                element.value === 'off'
                    ? toggleElement.classList.remove('on')
                    : toggleElement.classList.add('on');
            });
        });
    });
};
const switchTo = (checked, elements) => {
    let checkvalue = checked ? 'on' : 'off';
    elements.forEach(el => {
        if (el.value === checkvalue) {
            el.checked = true;
            el.dispatchEvent(new Event('change'));
            el.dispatchEvent(new Event('click'));
        }
    });
};
